import type { DisciplineTasksStore } from './interfaces'

import { emptyTutorTasksFilters } from '../../../lib/tutor-tasks-query'

export const actions = {
  setLoading (this: DisciplineTasksStore, payload: DisciplineTasksStore['loading']): void {
    this.loading = payload
  },
  setExporting (this: DisciplineTasksStore, payload: DisciplineTasksStore['exporting']): void {
    this.exporting = payload
  },
  setTasks (this: DisciplineTasksStore, payload: DisciplineTasksStore['tasks']): void {
    this.tasks = payload
  },
  setMeta (this: DisciplineTasksStore, payload: DisciplineTasksStore['meta']): void {
    this.meta = payload
  },
  setFilters (this: DisciplineTasksStore, payload: DisciplineTasksStore['filters']): void {
    this.filters = payload
  },
  patchFilters (this: DisciplineTasksStore, payload: Partial<DisciplineTasksStore['filters']>): void {
    this.filters = { ...this.filters, ...payload }
  },
  resetFilters (this: DisciplineTasksStore): void {
    this.filters = emptyTutorTasksFilters()
  },
  setCurrentPage (this: DisciplineTasksStore, payload: DisciplineTasksStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: DisciplineTasksStore, payload: DisciplineTasksStore['perPage']): void {
    this.perPage = payload
  },
  openModal (
    this: DisciplineTasksStore,
    modal: NonNullable<DisciplineTasksStore['activeModal']>,
    task: DisciplineTasksStore['activeTask'] = null,
  ): void {
    this.activeModal = modal
    this.activeTask = task
  },
  closeModal (this: DisciplineTasksStore): void {
    this.activeModal = null
    this.activeTask = null
  },
  /** The list answer goes with the page it was read for: the next visit starts empty, under its loader, never
   *  showing stale rows until its own land. Filters and paging stay. */
  resetList (this: DisciplineTasksStore): void {
    this.tasks = []
    this.meta = null
  },
}
